import React, {useEffect, useState} from "react";
import CountUp from "react-countup";
import {ResponseResultCode} from "app/model/response-api";
import {DbUserService} from "app/services/db/dbUserService";
import {ContractService} from "app/services/cb/ContractService";
import {DashboardModuleProps} from "../../../model/db/dashboardModuleProps";
import DashboardCard from "./DashboardCard";

export default function CntrMng(props: Readonly<DashboardModuleProps>) {
  const [trdCnt, setTrdCnt] = useState<any>({});

  useEffect(() => {
    getTrdCnt();
    fetchCntrStatus();
  }, []);

  const initialStatus: number[] = Array.from({ length: 3 }, (_) => 0);
  const [status, setStatus] = useState<number[]>(initialStatus);

  function fetchCntrStatus() {
    ContractService.getInstance().cntrStatistics()
    .then((response) => {
      if (response && ResponseResultCode.Y === response.resultCode) {
        setStatus(response.data.map((m) => m.value as number));
      } else {
        setStatus(initialStatus);
      }
    })
    .catch(() => setStatus(initialStatus));
  }

  async function getTrdCnt() {
    DbUserService.getInstance().getPPATrdCnt().then((response) => {
      if (response && ResponseResultCode.Y === response.resultCode) {
        setTrdCnt(response.data);
      }
    });
  }

  return (
    <DashboardCard
      title="계약 관리"
      isConfigMode={props.isConfigMode ?? false}
      moreButtonVisible={true}
      moreButtonUrl="/ot/contract"
      dashboardConfig={props.dashboardConfig}
    >
      <div className="row-col-gap3">
        <div className="box-solo">
          <div className="inner">
            <p>RE100 거래</p>
            <strong className="c-num"><em className="change">
              <CountUp end={status[2]} duration={0.5}>
                {({ countUpRef }) => <span ref={countUpRef} className="num" />}
              </CountUp>
            </em>건</strong>
          </div>
        </div>
        <div className="box-solo">
          <div className="inner">
            <p>직접 PPA 거래</p>
              <strong className="c-num"><em data-count={trdCnt?.drc ?? 0} className="change">
                <CountUp end={trdCnt?.drc ?? 0} duration={0.5}>
                  {({countUpRef}) => <span ref={countUpRef} className="num"/>}
                </CountUp></em>건</strong>
          </div>
        </div>
        <div className="box-solo">
          <div className="inner">
            <p>제 3자 PPA 거래</p>
            <strong className="c-num"><em data-count={trdCnt?.thd ?? 0} className="change">
              <CountUp end={trdCnt?.thd ?? 0} duration={0.5}>
                {({ countUpRef }) => <span ref={countUpRef} className="num" />}
              </CountUp></em>건</strong>
          </div>
        </div>
        <div className="box-solo">
          <div className="inner">
            <p>탄소 거래</p>
            <strong className="c-num"><em className="change">
              <CountUp end={status[1]} duration={0.5}>
                {({ countUpRef }) => <span ref={countUpRef} className="num" />}
              </CountUp></em>건</strong>
          </div>
        </div>
      </div>
    </DashboardCard>
  )
}